<template>
    <div
        v-if="visible"
        class="bo-snackbar"
        :class="{
            'slide-down': hideAnimation,
            danger: error,
        }"
    >
        <span v-if="!hasHtml">{{ message }}</span>
        <span
            v-else
            v-html="message"
        ></span>

        <div style="display: flex">
            <div
                v-if="customAction"
                class="close-btn"
                @click="redirect"
            >
                <span v-if="!hasHtml">{{ customActionText }}</span>
                <span
                    v-else
                    v-html="customActionText"
                ></span>
            </div>
            <div
                class="close-btn"
                @click="hideSnackbar"
            >
                <i class="icon-close"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            message: "",
            timeoutId: null,
            hideAnimation: false,
            customAction: false,
            customActionText: "",
            customActionUrl: "",
            hasHtml: false,
            error: false,
        };
    },
    methods: {
        showSnackbar(message, actionText = "", actionUrl = "", hasHtml = false, timeout = 3000, error = false) {
            this.message = message;
            this.visible = true;
            this.hideAnimation = false;
            this.hasHtml = hasHtml;
            this.error = error;

            if (this.timeoutId) clearTimeout(this.timeoutId);

            this.timeoutId = setTimeout(() => {
                this.hideSnackbar();
            }, timeout);

            if (actionText != "" && actionUrl != "") {
                this.customAction = true;
                this.customActionText = actionText;
                this.customActionUrl = actionUrl;
            }

            return new Promise((resolve) => {
                this.resolvePromise = resolve;
            });
        },
        hideSnackbar() {
            this.hideAnimation = true;

            setTimeout(() => {
                this.visible = false;
                this.message = "";
                this.resolvePromise(true);
            }, 300);
        },
        redirect() {
            window.location.assign(this.customActionUrl);
        },
    },
};
</script>
